{#if header}
    <th
        class="prom-cell__header prom-cell prom-cell__{type} prom-cell--priority-{priority}"
        scope="col"
        {colspan}
        {rowspan}>
        <slot name="header" />
        <slot name="header-data" />
    </th>
{:else}
    <td
        class="prom-cell__data prom-cell prom-cell__{type} prom-cell--priority-{priority}"
        {colspan}
        {rowspan}>
        <slot name="data" />
        <slot name="header-data" />
    </td>
{/if}

<script>
    /** @type {boolean} */
    export let header = false;
    /** @type {string} */
    export let type = undefined;
    /** @type {number} */
    export let colspan = 1;
    /** @type {number} */
    export let rowspan = 1;
    /** @type {1|2|3} */
    export let priority = 1;
</script>


